import React from 'react'
import PropTypes from 'prop-types'
import {
  PopUpContainer,
  PopUpContent,
  PopUpCuponContainer,
  PopUpCuponText,
  PopUpDescription,
  PopUpTitle,
  PopUpTitleContainer,
} from './PopUp.Style'
import 'react-lazy-load-image-component/src/effects/opacity.css'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { useDevices } from '@gojiraf/responsive'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton } from '@material-ui/core'
import { CouponIconSVG } from '../../assets/svg/CouponIconSVG'
import MessageWithLink from '../Chat/messages/MessageWithLink'
import { setIsNotificationVisible, setNotificationMessage } from '../../reducers/uiSlice'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

export const PopUp = ({ data }) => {
  const { postHogTrackEvent } = usePostHogAnalytics()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { isDesktop } = useDevices()
  const { title, promoCode, description } = data

  const showMessage = (message) => {
    dispatch(setNotificationMessage({ notificationMessage: message }))
    dispatch(setIsNotificationVisible({ isNotificationVisible: true }))
  }
  const copyCoupon = () => {
    postHogTrackEvent('copy-code', { code: promoCode })

    navigator.clipboard.writeText(promoCode)
    showMessage(t('uiElements.copyToClipboard').toUpperCase())
  }

  const showPopUp = !!title || !!promoCode || !!description

  return (
    <>
      {showPopUp ? (
        <PopUpContainer isMobile={!isDesktop}>
          <PopUpContent>
            {title && (
              <PopUpTitleContainer>
                <CouponIconSVG />
                <PopUpTitle>{title}</PopUpTitle>
              </PopUpTitleContainer>
            )}
            {promoCode && (
              <PopUpCuponContainer>
                <PopUpCuponText>{promoCode}</PopUpCuponText>
                <IconButton color="secondary" aria-label="copy" size="small" onClick={copyCoupon}>
                  <ContentCopyIcon />
                </IconButton>
              </PopUpCuponContainer>
            )}
            {description && (
              <PopUpDescription>
                <MessageWithLink logType="click-url-pop-up" isDesktop={isDesktop}>
                  {description}
                </MessageWithLink>
              </PopUpDescription>
            )}
          </PopUpContent>
        </PopUpContainer>
      ) : null}
    </>
  )
}

PopUp.propTypes = {
  data: PropTypes.object.isRequired,
}
